/**
 * 判断是手机、ipad、电脑
 *
 */
export default function isDeviceWidth() {
  let isMobile = false;
  let isTablet = false;
  let isDesktop = false;
  const width = screen.width || window.innerWidth;

  if (width <= 768) {
    isMobile = true;
  } else if (width > 768 && width <= 992) {
    isTablet = true;
  } else {
    isDesktop = true;
  }

  return {isMobile, isTablet, isDesktop};
}
